<div>
    <p-button class="mr-2" icon="pi pi-plus" label="Agregar Equipo" (click)="open()" styleClass="p-button-success p-button-outlined"></p-button>
</div>

<ng-template style="border: 0px; z-index: 100" #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title mb-0 font-semibold" id="modal-basic-title" style="font-family: 'Poppins', sans-serif;">{{ modoEdicion ? 'Editar equipo tecnológico' : 'Agregar un nuevo equipo tecnológico' }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="row">
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Tipo</mat-label>
                        <mat-select name="equipo.tipo" [(ngModel)]="equipo.tipo" (selectionChange)="onTipoChange()" required>
                            <mat-option class="example-full-width " *ngFor="let tipo of tiposEquipo" [value]="tipo">
                                {{ tipo }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col" *ngIf="modoEdicion">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Estado</mat-label>
                        <mat-select name="equipo.estado" [(ngModel)]="equipo.estado" required>
                            <mat-option class="example-full-width " *ngFor="let estado of estadosEquipo" [value]="estado">
                                {{ estado }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Marca</mat-label>
                        <mat-select name="equipo.marca" [(ngModel)]="equipo.marca" (selectionChange)="onMarcaChange()" [disabled]="!equipo.tipo" required>
                            <mat-option class="example-full-width " *ngFor="let marca of marcasDisponibles" [value]="marca">
                                {{ marca }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Modelo</mat-label>
                        <input type="text" maxlength="100" minlength="1" matInput required name="equipo.modelo" [(ngModel)]="equipo.modelo" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Número de serie</mat-label>
                        <input type="text" maxlength="100" minlength="1" matInput required name="equipo.numeroSerie" [(ngModel)]="equipo.numeroSerie"
                               (blur)="onNumeroSerieBlur()" />
                    </mat-form-field>
                    <div *ngIf="equiposSimilaresEncontrados.length > 0" class="alert alert-warning p-2">
                        <small>¿Es este equipo? Ya existe uno muy parecido en el catálogo:</small>
                        <div class="list-group">
                            <button type="button" class="list-group-item list-group-item-action" *ngFor="let eq of equiposSimilaresEncontrados"
                                    (click)="usarEquipoSimilar(eq)">
                                {{ eq.tipo }} - {{ eq.marca }} {{ eq.modelo }} (S/N: {{ eq.numeroSerie }})
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Chip</mat-label>
                        <input type="text" maxlength="50" matInput name="equipo.chip" [(ngModel)]="equipo.chip" [disabled]="!chipHabilitado" placeholder="Opcional, ej: M1, M2, M3..." />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Accesorios</mat-label>
                        <input type="text" maxlength="255" matInput name="equipo.accesorios" [(ngModel)]="equipo.accesorios" placeholder="Opcional, ej: cargador, mouse" />
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Observación</mat-label>
                        <input type="text" maxlength="255" matInput name="equipo.observacion" [(ngModel)]="equipo.observacion" placeholder="Opcional" />
                    </mat-form-field>
                </div>
            </div>

            <ng-container *ngIf="appleIdHabilitado">
                <hr />
                <p class="text-muted mb-2">Datos de Apple ID (opcional, solo visibles/editables por el admin)</p>
                <div class="row">
                    <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>Correo Apple ID</mat-label>
                            <input type="email" maxlength="255" matInput name="equipo.appleIdCorreo" [(ngModel)]="equipo.appleIdCorreo" placeholder="Opcional" />
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>Contraseña Apple ID</mat-label>
                            <input [type]="mostrarContrasenaAppleId ? 'text' : 'password'" maxlength="255" matInput
                                   name="equipo.appleIdContrasena" [(ngModel)]="equipo.appleIdContrasena" placeholder="Opcional" />
                            <button mat-icon-button matSuffix type="button" (click)="mostrarContrasenaAppleId = !mostrarContrasenaAppleId">
                                <mat-icon>{{ mostrarContrasenaAppleId ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>Número de recuperación</mat-label>
                            <input type="text" maxlength="50" matInput name="equipo.numeroRecuperacion" [(ngModel)]="equipo.numeroRecuperacion" placeholder="Opcional" />
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>Dueño del número de recuperación</mat-label>
                            <input type="text" maxlength="255" matInput name="equipo.duenoNumeroRecuperacion" [(ngModel)]="equipo.duenoNumeroRecuperacion" placeholder="Opcional" />
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">Cancelar</span>
      </button>
        <button type="button" class="btn btn-outline-success" (click)="guardar()">
        Guardar
      </button>
    </div>
</ng-template>
